module.exports = __webpack_public_path__ + "res/roboto-v15-latin-500italic.woff";


//////////////////
// WEBPACK FOOTER
// ./client/app/vendor/googlefonts/roboto-v15-latin-500italic.woff
// module id = 101
// module chunks = 1